// src/utils/context/get-device/get-device.ts
import { UAParser } from "ua-parser-js";
async function getDevice() {
  const ua = new UAParser().getResult();
  return {
    browser: {
      name: ua.browser.name,
      version: ua.browser.version
    },
    device: {
      manufacturer: ua.device.vendor,
      model: ua.device.model,
      platform: "Web",
      primary_locale: document.documentElement.lang ?? window.yvaDatastore?.config.localeFallback,
      system_name: ua.os.name,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      type: "WEB",
      version: ua.os.version
    }
  };
}

export {
  getDevice
};
